// 上传文件的最大的大小限制
export const FILE_LIMIT = 10 * 1024 * 1024
